<template>
    <div @click="$emit('click')" :class="{chosed: chosen>=0}" class="button">
            <span class="additional">{{modifier}}</span>
            <span class="param-name">{{label}}</span>
            <span class="additional">{{value}}</span>
    </div>
</template>

<script>
    import store from "../assets/store";
    export default {
        props: ["label", "paramindex"],
        data() {
            return {
                store: store
            };
        },
        computed: {
            chosen() {
                return this.store.params[this.paramindex].chosen;
            },
            modifier() {
                return this.chosen >= 0 ?
                    "+ " +
                    this.store.params[this.paramindex].values[this.chosen]
                    .mod :
                    " ";
            },
            value() {
                return this.chosen >= 0 ?
                    this.store.params[this.paramindex].values[this.chosen]
                    .value :
                    " ";
            }
        }
    };
</script>

<style scoped>
    .button {
        background: #f2f2f2;
box-shadow:  5px 5px 10px #acacac, 
             -5px -5px 10px #ffffff;
        border-radius: 40px;
        margin: 10px;
        color: #004369;
        padding: 10px;
        cursor: pointer;
        display: grid;
        grid-template-columns: 80px 1fr 70px;
    }

    .chosed {
        background: #F4FBFF;
    }

    .additional {
        color: #006AA6;
        font-weight: 500;
    }

    .param-name {
        text-align: left;
    }
</style>